import * as React from 'react';
import ViewWrapper from '../../components/ViewWrapper/ViewWrapper';
import ViewHeading from '../../components/ViewHeading/ViewHeading';
import './styles.scss';

const MainComponent: React.FC<any> = ({ children, title, pageName, controls, isSearch = true }) => {
    return (
        <>
            <ViewWrapper
                {...{
                    requireAuth: true,
                    title: title,
                    isNotRedirected: true,
                }}
            >
                <ViewHeading controls={controls} isSmall={true} isSearch={isSearch}>
                    {pageName}
                </ViewHeading>
                <div className="bg">
                    {children}
                </div>
            </ViewWrapper>
        </>
    );
};

export default MainComponent;

